import styled from '@emotion/styled';
import { HStack } from '@lib/uikit';
import capitalize from '@utils/string/capitalize';

import { Select } from './hooks/useVariantSelects';
import { OptionLabel } from './OptionLabel';

const RadioInput = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    background: ${({ theme }) => theme.palette.grey[100]};
    color: ${({ theme }) => theme.palette.grey[900]};
    border-radius: ${({ theme }) => theme.shape.radius.xs};
    padding-inline: ${({ theme }) => theme.spacing.sm};
    padding-block: ${({ theme }) => theme.spacing.xs};
    &:has(input:checked) {
        background: ${({ theme }) => theme.palette.grey[900]};
        color: ${({ theme }) => theme.palette.grey[50]};
    }
`;

export const VariantRadioSelect = ({
    select,
    onSelectOption,
}: {
    select: Select;
    onSelectOption: (optionName: string, value: string) => void;
}) => {
    return (
        <HStack spacing='xs' alignItems='start'>
            <OptionLabel>{capitalize(select.name)}</OptionLabel>
            <HStack
                width='100%'
                justifyContent='left'
                spacing='xs'
                flexWrap='wrap'
                rowSpacing='xxs'
            >
                {select.options.map((option) => (
                    <RadioInput key={option.value}>
                        <input
                            type='radio'
                            name={select.name}
                            value={option.value}
                            checked={select.value === option.value}
                            style={{ display: 'none' }}
                            onChange={(e) =>
                                onSelectOption(select.name, e.target.value)
                            }
                        />
                        {capitalize(option.value)}
                    </RadioInput>
                ))}
            </HStack>
        </HStack>
    );
};
